import symbolAnimation from '../utils/symbolAnimation'

import BaseIntersection from './BaseIntersection'

export default {
  components: { BaseIntersection },
  provide() {
    // binds entire component to animation
    // symbol allowing a flexible DOM structure
    return { [symbolAnimation]: this }
  },

  props: {
    tag: {
      type: String,
      default: 'div',
    },
    replay: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    previousIsIntersecting: undefined,
  }),

  methods: {
    handleCallback({ isIntersecting }) {
      const { previousIsIntersecting, replay } = this
      if (previousIsIntersecting === undefined && replay) {
        this.previousIsIntersecting = isIntersecting
        return
      }

      if (isIntersecting === previousIsIntersecting) {
        return
      }

      if (!replay && !isIntersecting) {
        return
      }

      this.previousIsIntersecting = isIntersecting
    },
  },

  render(h) {
    const props = {
      tag: this.tag,
      callback: this.handleCallback,
    }
    return h('BaseIntersection', { props }, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/components/BaseAnimation.js